/**
 *
 * @param code '1F468-200D-1F9B0'
 * @returns 👨‍🦰
 */
export default function unifiedToEmoji(code: string) {
  const codePoints = code.split('-');
  return codePoints.map((cp) => String.fromCodePoint(parseInt(cp, 16))).join('');
}
